(function () {
  "use strict";

  function initSubscriptionBox(box) {
    if (!box || box.dataset.initialized === "true") return;

    box.dataset.initialized = "true";

    var productId = box.dataset.productId;
    var servingsPerUnit = Number(box.dataset.servingsPerUnit) || 1;
    // Precio por bote (Reset): una «toma» = un bote para todos los cálculos.
    var perBote = box.dataset.pricePer === 'bote';
    if (perBote) servingsPerUnit = 1;
    var tierDisplayMode = box.dataset.tierDisplayMode || "units";
    var doseUnitLabel = box.dataset.doseUnitLabel || 'dosis';
    var quantityTiers = box.querySelectorAll("[data-quantity-tier]");
    var itemsWrapper = box.querySelector("[data-quantity-items]");
    var purchaseOptions = box.querySelectorAll("[data-option]");
    var sellingPlanButtons = box.querySelectorAll("[data-selling-plan]");

    var oneTimePrice = box.querySelector("[data-one-time-price]");
    var oneTimeUnitPrice = box.querySelector("[data-one-time-unit-price]");
    var subscriptionPrice = box.querySelector("[data-subscription-price]");
    var subscriptionUnitPrice = box.querySelector(
      "[data-subscription-unit-price]",
    );
    var quantityMessage = box.querySelector("[data-quantity-message]");
    // Óscar 25/10: precio de un bote (con la oferta) en la caja.
    var zUnitPrice = box.querySelector("[data-zunit-price]");
    var zUnitCompare = box.querySelector("[data-zunit-compare]");
    var zSubUnitPrice = box.querySelector("[data-zsub-unit-price]");
    var zUnitLabels = box.querySelectorAll("[data-zunit-label]");
    function zdRenderUnit(unit, compare, subUnit, perUnit) {
      zUnitLabels.forEach(function (el) { el.hidden = !perUnit; });
      if (zUnitPrice) zUnitPrice.textContent = formatMoney(unit);
      if (zUnitCompare) {
        var show = perUnit && compare > unit;
        zUnitCompare.hidden = !show;
        zUnitCompare.textContent = show ? formatMoney(compare) : "";
      }
      if (zSubUnitPrice) zSubUnitPrice.textContent = formatMoney(subUnit);
    }
    // Óscar 21/10: «Ahorras X €» y «X €/toma» junto al titulo (la barra fija
    // los copia con el resto del bloque de descuento).
    var summaryEl = box.querySelector("[data-zsum]");
    var savingsEl = box.querySelector("[data-zsave]");
    var doseEl = box.querySelector("[data-zdose]");
    var subDoseEl = box.querySelector("[data-zsub-dose]");
    var cycleDoseEls = box.querySelectorAll("[data-zcycle-dose]");
    var variantServings = {};
    try { variantServings = JSON.parse(box.dataset.variantServings || "{}"); } catch (e) {}

    var productForm =
      document.querySelector("#product-form-" + productId) ||
      box.closest("product-form") ||
      box.closest("form");

    var currentQuantity = 1;
    var currentDiscount = 0;
    var extraPrice = 0;
    var extraQty = 0;
    // Con selector de pack: precios ya separados en botes (con descuento) y
    // muestras (sin descuento). Ver ppgGetTotals en el selector.
    var pickerPricing = null;
    // Óscar 24/10: hasta que el cliente añade un bote, la etiqueta de compra
    // única enseña «Hasta X €/toma» con el mayor descuento por cantidad.
    var zdTouched = false;
    // Óscar 22/10: el descuento por cantidad cuenta todos los botes del
    // carrito (compra única). La barra y el tramo arrancan con los que ya hay
    // en la cesta del mismo grupo (botes: tipo «Tubo»; Reset: «gominolas»).
    var cartBase = 0;
    var lastQtyOptions = null;
    var zdMeta = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) || {};
    var zdGroupType = /gominolas/i.test(zdMeta.type || "") ? "gominolas" : (/^tubo$/i.test(zdMeta.type || "") ? "Tubo" : (box.closest("[data-ppg-root], .product-info, main") && document.querySelector("[data-ppg-tiers]") ? "Tubo" : ""));
    function implicitTube() {
      return !!(pickerPricing && pickerPricing.implicitTube);
    }
    function tierQtyFor(quantity) {
      return quantity + cartBase;
    }

    /* =====================================
       FIND PRODUCT FORM
    ===================================== */

    function getProductForm() {
      if (productForm) return productForm;
      productForm = document.querySelector('form[action*="/cart/add"]');
      return productForm;
    }

    /* =====================================
       GET QUANTITY INPUT
    ===================================== */

    function getQuantityInput() {
      var form = getProductForm();
      if (!form) return null;

      var input =
        form.querySelector('input[name="quantity"]') ||
        form.querySelector('[name="quantity"]');

      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "quantity";
        form.appendChild(input);
      }

      return input;
    }

    /* =====================================
       SET QUANTITY
    ===================================== */

    function writeFormQuantity(quantity) {
      var input = getQuantityInput();
      if (!input) return;

      input.value = quantity;

      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));

      var alpineEl = input.closest("[x-data]");
      if (alpineEl && window.Alpine && typeof window.Alpine.$data === "function") {
        try {
          window.Alpine.$data(alpineEl).quantity = quantity;
        } catch (error) {}
      }
    }

    function setQuantity(quantity) {
      currentQuantity = quantity;
      writeFormQuantity(quantity);
    }

    /* =====================================
       FORMAT MONEY
    ===================================== */

    function formatMoney(cents) {
      var amount = cents / 100;

      return new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency:
          window.Shopify && Shopify.currency && Shopify.currency.active
            ? Shopify.currency.active
            : "EUR",
      }).format(amount);
    }

    /* =====================================
       FIND ACTIVE TIER FOR A GIVEN QUANTITY
       (highest tier whose threshold <= quantity)
    ===================================== */

    function getActiveTier(quantity) {
      var active = null;

      quantityTiers.forEach(function (tier) {
        var tierQuantity = Number(tier.dataset.quantity);

        if (
          tierQuantity <= quantity &&
          (!active || tierQuantity > Number(active.dataset.quantity))
        ) {
          active = tier;
        }
      });

      return active || quantityTiers[0] || null;
    }

    /* =====================================
       UPDATE QUANTITY UI
       (tier highlight, progress bar, message)
    ===================================== */

    /* Ancho de la parte activa de la barra (Changes Oscar 05-10). Las
       posiciones salen de la misma rejilla que pinta los escalones, asi que
       el ultimo escalon es el 100% exacto, y entre dos escalones avanza en
       proporcion (1 bote de 2 = medio camino al primero). Va como calc()
       con % para que la copia de la barra fija lo resuelva con su ancho. */
    function progressWidth(quantity, sortedTiers) {
      var n = sortedTiers.length;
      if (!n || quantity <= 0) return "0px";
      var qs = sortedTiers.map(function (t) { return Number(t.dataset.quantity) || 0; });
      var colW = "((100% - 30px - " + (n - 1) + " * var(--qd-gap, 0px)) / " + n + ")";
      function centerAt(pos) {
        return "(15px + " + (pos + 0.5) + " * " + colW + " + " + pos + " * var(--qd-gap, 0px) - 14px)";
      }
      if (quantity < qs[0]) {
        var frac = qs[0] > 0 ? quantity / qs[0] : 0;
        return "calc(" + centerAt(0) + " * " + frac.toFixed(4) + ")";
      }
      var pos = n - 1;
      for (var i = 0; i < n - 1; i++) {
        if (quantity < qs[i + 1]) {
          pos = i + (quantity - qs[i]) / (qs[i + 1] - qs[i]);
          break;
        }
      }
      return "calc" + centerAt(Number(pos.toFixed(4)));
    }

    function updateQuantityUI(quantity, discount) {
      var result = window.ZQuantityProgress.render({
        tierEls: quantityTiers,
        qty: quantity,
      });

      var sorted = window.ZQuantityProgress.getSortedTiers(quantityTiers);
      var firstTier = sorted[0] || null;
      var firstQty = firstTier ? Number(firstTier.dataset.quantity) : 0;

      if (itemsWrapper) {
        itemsWrapper.style.setProperty("--qd-cols", String(sorted.length || 3));
        itemsWrapper.style.setProperty("--quantity-progress", progressWidth(quantity, sorted));
      }

      if (firstTier && quantity < firstQty) {
        if (itemsWrapper) {
          delete itemsWrapper.dataset.activeTier;
        }

        quantityTiers.forEach(function (tier) {
          tier.classList.remove("is-active", "is-current", "is-reached");
        });

        if (quantityMessage) {
          quantityMessage.innerHTML = cartPrefix() +
            zdT(cartBase > 0 ? "tiersAddMoreLower" : "tiersAddMore", {
              tubs: botesLabel(firstQty - quantity),
              pct: Number(firstTier.dataset.discount) || 0,
            });
        }
        return;
      }

      if (itemsWrapper && result.activeTier) {
        itemsWrapper.dataset.activeTier = result.activeTier.dataset.quantity;
      }

      if (!quantityMessage || !result.activeTier) return;

      if (!result.nextTier) {
        var maxDiscount = Number(result.activeTier.dataset.discount) || 0;
        quantityMessage.innerHTML = cartPrefix() + (
          maxDiscount > 0
            ? zdT("tiersGotPct", { pct: maxDiscount })
            : zdT("tiersGotMax"));
        return;
      }

      var nextQuantity = Number(result.nextTier.dataset.quantity);
      var nextDiscount = Number(result.nextTier.dataset.discount);
      var quantityToAdd = Math.max(1, nextQuantity - quantity);

      quantityMessage.innerHTML = cartPrefix() +
        zdT(cartBase > 0 ? "tiersAddMoreLower" : "tiersAddMore", {
          tubs: botesLabel(quantityToAdd),
          pct: nextDiscount,
        });
    }

    // Óscar 12/10: «Añade 2 botes más», no «Añade 2 más», para que no
    // parezca que las muestras cuentan para el descuento.
    function cartPrefix() {
      return cartBase > 0 ? zdT("tiersCartPrefix", { tubs: botesLabel(cartBase) }) + " " : "";
    }

    function botesLabel(n) {
      return n === 1 ? zdT("tubsOne") : zdT("tubsOther", { num: n });
    }

    function zdBestOneTimeDose() {
      var base = Number(box.dataset.basePrice || 0);
      if (!base || !(servingsPerUnit > 1 || perBote)) return null;
      var maxDisc = 0;
      quantityTiers.forEach(function (t) {
        var d = Number(t.dataset.discount) || 0;
        if (d > maxDisc) maxDisc = d;
      });
      if (!maxDisc) return null;
      return Math.round(base * (1 - maxDisc / 100) / servingsPerUnit);
    }

    function renderSummary(savingsCents, perDoseCents) {
      if (!summaryEl) return;
      var showSave = savingsCents > 0;
      var showDose = perDoseCents != null && perDoseCents > 0;
      if (savingsEl) {
        savingsEl.hidden = !showSave;
        if (showSave) savingsEl.textContent = zdT("youSave", { amount: formatMoney(savingsCents) });
      }
      if (doseEl) {
        doseEl.hidden = !showDose;
        if (showDose) {
          var best = !zdTouched ? zdBestOneTimeDose() : null;
          doseEl.textContent = best
            ? zdT("upTo", { amount: formatMoney(best) + "/" + doseUnitLabel })
            : formatMoney(perDoseCents) + "/" + doseUnitLabel;
        }
      }
      summaryEl.hidden = !(showSave || showDose);
      // Copia junto al precio de «Compra única» (en la caja el bloque de
      // arriba se oculta; la barra fija sigue copiando el original).
      var priceChips = box.querySelector("[data-zsum-price]");
      if (priceChips) {
        priceChips.innerHTML = "";
        // Óscar 25/10: en Reset (precio por bote) el €/bote ya es el precio
        // grande de la caja; no se repite ahí, pero sí en la barra fija.
        [savingsEl, perBote ? null : doseEl].forEach(function (el) {
          if (el && !el.hidden) {
            var c = el.cloneNode(true);
            c.removeAttribute("data-zsave");
            c.removeAttribute("data-zdose");
            priceChips.appendChild(c);
          }
        });
      }
    }

    // Suscripcion: sin descuento por cantidad (Óscar 21/10). Precio completo,
    // €/toma del primer pedido y, en cada «Pedido N», el €/toma con el % de
    // ese pedido (se lee del texto de la recompensa, p. ej. «5% + envío gratis»).
    function renderSubscription(subTotal, servings) {
      var perDose = servings > 0 ? Math.round(subTotal / servings) : null;
      var doseText = perDose ? formatMoney(perDose) + "/" + doseUnitLabel : "";
      if (subscriptionPrice) subscriptionPrice.textContent = formatMoney(subTotal);
      if (subscriptionUnitPrice) subscriptionUnitPrice.textContent = doseText;
      if (subDoseEl) {
        // Óscar 24/10: «Hasta X €/toma» con el mejor precio (último pedido).
        var maxPct = 0;
        cycleDoseEls.forEach(function (el) {
          var p = Number(el.dataset.zcyclePct) || 0;
          if (p > maxPct) maxPct = p;
        });
        var bestDose = servings > 0 ? Math.round(subTotal * (1 - maxPct / 100) / servings) : null;
        subDoseEl.hidden = !bestDose;
        subDoseEl.textContent = bestDose ? (maxPct > 0 ? zdT("upTo", { amount: formatMoney(bestDose) + "/" + doseUnitLabel }) : formatMoney(bestDose) + "/" + doseUnitLabel) : "";
      }
      cycleDoseEls.forEach(function (el) {
        var pct = Number(el.dataset.zcyclePct) || 0;
        if (!servings) { el.hidden = true; return; }
        el.textContent = formatMoney(Math.round(subTotal * (1 - pct / 100) / servings)) + "/" + doseUnitLabel;
        el.hidden = false;
      });
    }

    function updatePricePreview() {
      var basePrice = Number(box.dataset.basePrice || 0);
      if (!basePrice) return;

      if (pickerPricing) {
        // Solo los botes llevan el descuento por cantidad; las muestras se
        // suman a precio completo.
        var units = Math.max(1, pickerPricing.units);
        var total = Math.round(
          pickerPricing.tubesPrice * (1 - currentDiscount / 100) + pickerPricing.samplesPrice,
        );
        // Tomas reales del pack (cada bote con las suyas); si falta el dato
        // de algun bote, sin €/toma.
        var packServings = pickerPricing.servingsMissing ? 0 : pickerPricing.servings;
        var perDose = packServings > 0 ? Math.round(total / packServings) : null;
        var doseText = perDose ? formatMoney(perDose) + "/" + doseUnitLabel : "";
        renderSummary(Math.round(pickerPricing.tubesPrice * currentDiscount / 100), perDose);
        if (oneTimePrice) oneTimePrice.textContent = formatMoney(total);
        if (oneTimeUnitPrice) oneTimeUnitPrice.textContent = doseText;
        // Solo botes en el pack: precio por bote; con muestras, el total.
        if (!pickerPricing.samplesPrice && units > 0) {
          zdRenderUnit(
            Math.round(pickerPricing.tubesPrice * (1 - currentDiscount / 100) / units),
            Math.round(pickerPricing.tubesPrice / units),
            Math.round(pickerPricing.tubesPrice / units),
            true,
          );
        } else {
          zdRenderUnit(total, 0, Math.round(pickerPricing.tubesPrice + pickerPricing.samplesPrice), false);
        }
        renderSubscription(
          Math.round(pickerPricing.tubesPrice + pickerPricing.samplesPrice),
          packServings,
        );
        return;
      }

      var selfQty = Math.max(currentQuantity - extraQty, 0);
      var originalTotal = basePrice * selfQty + extraPrice;
      var effectiveBase = currentQuantity > 0 ? originalTotal / currentQuantity : basePrice;
      var discountedTotal = Math.round(
        originalTotal * (1 - currentDiscount / 100),
      );
      var discountedUnitPrice = Math.round(
        discountedTotal / (currentQuantity * servingsPerUnit),
      );
      renderSummary(
        originalTotal - discountedTotal,
        (servingsPerUnit > 1 || perBote) ? discountedUnitPrice : null,
      );

      if (oneTimePrice) {
        oneTimePrice.textContent = formatMoney(discountedTotal);
      }
      var zq = Math.max(currentQuantity, 1);
      zdRenderUnit(
        Math.round(discountedTotal / zq),
        Math.round(originalTotal / zq),
        Math.round(originalTotal / zq),
        true,
      );
      if (oneTimeUnitPrice) {
        oneTimeUnitPrice.textContent =
          (servingsPerUnit > 1 || perBote) ? formatMoney(discountedUnitPrice) + '/' + doseUnitLabel : '';
      }

      renderSubscription(
        Math.round(originalTotal),
        (servingsPerUnit > 1 || perBote) ? currentQuantity * servingsPerUnit : 0,
      );

      quantityTiers.forEach(function (tier) {
        if (tierDisplayMode !== "price_per_dose") return;

        var quantity = Number(tier.dataset.quantity);
        var discount = Number(tier.dataset.discount);

        var tierTotal = Math.round(effectiveBase * quantity * (1 - discount / 100));
        var tierUnitPrice = Math.round(
          tierTotal / (quantity * servingsPerUnit),
        );

        var priceElement = tier.querySelector("[data-tier-price]");

        if (priceElement) {
          priceElement.textContent = formatMoney(tierUnitPrice) + '/' + doseUnitLabel;
        }
      });
    }

    /* =====================================
       APPLY QUANTITY — single source of truth.

       Call this from:
       - a tier click
       - window.updateSubscriptionQuantity(n) / box.updateSubscriptionQuantity(n)
       - the `ppg:quantity-changed` event fired by product-picker-grid.liquid
    ===================================== */

    function applyQuantity(quantity, options) {
      options = options || {};
      quantity = Number(quantity);
      if (isNaN(quantity)) quantity = 1;
      // Con el selector de pack la cantidad es la real de botes y puede ser 0
      // (pack vacio o solo muestras): la barra tiene que enseñar eso.
      if (quantity < (options.allowZero ? 0 : 1)) quantity = options.allowZero ? 0 : 1;

      lastQtyOptions = { quantity: quantity, allowZero: !!options.allowZero, fromPicker: !!options.fromPicker };
      var tierQty = tierQtyFor(quantity);
      var sortedTiers = window.ZQuantityProgress.getSortedTiers(quantityTiers);
      var activeIndex = window.ZQuantityProgress.getActiveIndex(
        sortedTiers,
        tierQty,
      );
      var activeTier = sortedTiers[activeIndex] || null;
      currentDiscount = activeTier
        ? Number(activeTier.dataset.discount) || 0
        : 0;

      if (!options.skipFormQuantity) {
        setQuantity(quantity);
      } else {
        currentQuantity = quantity;
      }

      updateQuantityUI(tierQty, currentDiscount);
      updatePricePreview();

      if (!options.fromExternalSync) {
        document.dispatchEvent(
          new CustomEvent("product-qty-sync:changed", {
            detail: {
              quantity: quantity,
              source: "subscription-box",
              productId: productId,
              fromPicker: !!options.fromPicker,
            },
          }),
        );
      }
    }

    // Public API. Scoped per box (safe with multiple boxes on the page) and
    // also exposed on window for convenience when only one box exists.
    box.updateSubscriptionQuantity = applyQuantity;
    window.updateSubscriptionQuantity = applyQuantity;

    /* =====================================
       QUANTITY TIER CLICK (manual)
    ===================================== */

    quantityTiers.forEach(function (tier) {
      tier.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        // Con botes ya en la cesta, el tramo pulsado es el total del carrito.
        zdTouched = true;
        applyQuantity(Math.max(1, Number(tier.dataset.quantity) - cartBase));
      });
    });

    /* =====================================
       PURCHASE OPTION
    ===================================== */

    purchaseOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        var type = option.dataset.option;

        purchaseOptions.forEach(function (item) {
          item.classList.toggle('is-active', item === option);
        });

        if (type === 'subscription') {
          var firstPlanButton = box.querySelector('[data-selling-plan]');
          if (firstPlanButton) {
            setSellingPlan(firstPlanButton.dataset.sellingPlan);
          }
        } else {
          removeSellingPlan();
        }
      });
    });


    /* =====================================
       SELLING PLAN
    ===================================== */

    function setSellingPlan(planId) {
      var form = getProductForm();
      if (!form || !planId) return;

      var input = form.querySelector('input[name="selling_plan"]');

      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "selling_plan";
        form.appendChild(input);
      }

      input.value = planId;
    }

    function removeSellingPlan() {
      var form = getProductForm();
      if (!form) return;

      var input = form.querySelector('input[name="selling_plan"]');
      if (input) input.remove();
    }

    /* =====================================
       SELLING PLAN CLICK
    ===================================== */

    sellingPlanButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        sellingPlanButtons.forEach(function (item) {
          item.classList.remove("is-active");
        });

        button.classList.add("is-active");
        setSellingPlan(button.dataset.sellingPlan);
      });
    });

    document.addEventListener("subscription-plan:changed", function (event) {
      var activeOption = box.querySelector(".subscription-option--subscription.is-active");
      if (!activeOption) return;
      var id = event.detail && event.detail.sellingPlanId;
      if (id) setSellingPlan(id);
    });

    /* =====================================
       VARIANTE SIN PLAN (Óscar 09/10: solo botes de 70 tomas)
       Si la variante elegida no tiene plan de suscripcion, se oculta
       «Suscríbete» y se vuelve a compra unica, para no mandar un
       selling_plan que Shopify rechazaria.
    ===================================== */

    function syncSubscriptionAvailability(variantId) {
      var subOption = box.querySelector('.subscription-option--subscription');
      if (!subOption || box.dataset.planVariants == null) return;
      var ids = box.dataset.planVariants.split(',').filter(Boolean);
      var hasPlan = ids.indexOf(String(variantId)) !== -1;
      subOption.hidden = !hasPlan;
      if (!hasPlan && subOption.classList.contains('is-active')) {
        var oneTime = box.querySelector('.subscription-option--one-time');
        if (oneTime) oneTime.click();
      }
    }

    /* =====================================
       VARIANT CHANGE
    ===================================== */

    document.addEventListener("shapes:product:variantchange", function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;

      box.dataset.variantId = variant.id;
      box.dataset.basePrice = variant.price;
      if (variantServings[variant.id] && !perBote) servingsPerUnit = Number(variantServings[variant.id]) || 1;

      syncSubscriptionAvailability(variant.id);
      updatePricePreview();
    });

    /* =====================================
       NEW: PRODUCT PICKER GRID INTEGRATION

       product-picker-grid.liquid dispatches:
         document.dispatchEvent(new CustomEvent('ppg:quantity-changed', {
           detail: { totalQuantity: <number> }
         }))
       every time a product is added or its stepper qty changes.
       We just feed that number straight into applyQuantity().
    ===================================== */

    document.addEventListener("ppg:quantity-changed", function (event) {
      var d = event.detail || {};
      if (d.totalQuantity == null) return;
      extraPrice = Number(d.othersPrice) || 0;
      extraQty = Number(d.othersQuantity) || 0;
      pickerPricing = d.tubesPrice != null ? {
        tubesPrice: Number(d.tubesPrice) || 0,
        samplesPrice: Number(d.samplesPrice) || 0,
        units: (Number(d.packQuantity) || 0) + (d.implicitSelf ? 1 : 0),
        servings: Number(d.servings) || 0,
        servingsMissing: d.servings == null || !!d.servingsMissing,
        implicitTube: !!d.implicitSelf && (Number(d.totalQuantity) || 0) === 0 && (Number(d.tubesPrice) || 0) > 0,
      } : null;
      if ((Number(d.totalQuantity) || 0) > 0) zdTouched = true;
      applyQuantity(d.totalQuantity, { skipFormQuantity: true, fromPicker: true, allowZero: true });
      writeFormQuantity(Number(d.selfQuantity) || 1);
    });

    document.addEventListener("product-qty-sync:changed", function (event) {
      var detail = event.detail || {};
      if (detail.source === "subscription-box") return;
      if (
        detail.productId != null &&
        String(detail.productId) !== String(productId)
      )
        return;
      if (detail.quantity == null) return;
      if (Number(detail.quantity) !== Number(currentQuantity)) zdTouched = true;
      applyQuantity(detail.quantity, { fromExternalSync: true });
    });

    /* =====================================
       DEFAULT

       Changed from the previous hardcoded (3, 15%) default to (1, 0%):
       when this box is paired with the product picker, nothing has been
       added yet on page load, so starting at tier 1 matches reality.
       If you use this box WITHOUT the picker and still want it to default
       to the top tier, replace the line below with: applyQuantity(3);
    ===================================== */

    applyQuantity(1);

    function zdCountCart(cart) {
      if (!zdGroupType) return 0;
      var n = 0;
      (cart.items || []).forEach(function (i) {
        if (i.selling_plan_allocation || !(i.final_line_price > 0)) return;
        if (String(i.product_type || "").toLowerCase() === zdGroupType.toLowerCase()) n += i.quantity;
      });
      return n;
    }
    function zdRefreshCartBase() {
      if (!zdGroupType) return;
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = zdCountCart(cart);
          window.zdCartTierBase = window.zdCartTierBase || {};
          window.zdCartTierBase[zdGroupType] = n;
          if (n === cartBase) return;
          cartBase = n;
          document.dispatchEvent(new CustomEvent("zd:cart-base", { detail: { type: zdGroupType, count: n } }));
          var o = lastQtyOptions || { quantity: currentQuantity };
          applyQuantity(o.quantity, { skipFormQuantity: true, fromExternalSync: true, allowZero: o.allowZero, fromPicker: o.fromPicker });
        })
        .catch(function () {});
    }
    var zdBaseTimer;
    function zdScheduleBase() { clearTimeout(zdBaseTimer); zdBaseTimer = setTimeout(zdRefreshCartBase, 300); }
    document.addEventListener("shapes:cart:afteradditem", zdScheduleBase);
    document.addEventListener("cart:updated", zdScheduleBase);
    window.addEventListener("pageshow", zdScheduleBase);
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var k = 0; k < muts.length; k++) {
          var tg = muts[k].target;
          if (tg.closest && tg.closest("[data-cart-items]")) { zdScheduleBase(); return; }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    zdRefreshCartBase();

    /*
     * If subscription exists, default to first selling plan.
     */
    var firstPlan = box.querySelector("[data-selling-plan]");
    if (firstPlan) {
      firstPlan.classList.add("is-active");
    }
  }

  /* =====================================
     INIT
  ===================================== */

  function init() {
    document
      .querySelectorAll("[data-subscription-box]")
      .forEach(function (box) {
        initSubscriptionBox(box);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
